import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';

const buildAppLayoutGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const useDidSeeUtmIntro = buildAppLayoutGetterObject('useDidSeeUtmIntro');
export const useIsProjectMenuPinned = buildAppLayoutGetterObject('useIsProjectMenuPinned');
export const useShowInspirationCenter = buildAppLayoutGetterObject('useShowInspirationCenter');
export const useIsNotificationsPinned = buildAppLayoutGetterObject('useIsNotificationsPinned');
export const useSeenInterfaceExplanation = buildAppLayoutGetterObject('useSeenInterfaceExplanation');
export const useDismissedSpaceTabExplanation = buildAppLayoutGetterObject('useDismissedSpaceTabExplanation');
export const useDismissedPlacementTabExplanation = buildAppLayoutGetterObject('useDismissedPlacementTabExplanation');
const getters = {
	[useDidSeeUtmIntro.getter]: (state) => state.didSeeUtmIntro,
	[useIsProjectMenuPinned.getter]: (state) => state.isProjectMenuPinned,
	[useIsNotificationsPinned.getter]: (state) => state.isNotificationsPinned,
	[useShowInspirationCenter.getter]: (state) => state.showInspirationCenter,
	[useSeenInterfaceExplanation.getter]: (state) => state.seenInterfaceExplanation,
	[useDismissedSpaceTabExplanation.getter]: (state) => state.dismissedSpaceTabExplanation,
	[useDismissedPlacementTabExplanation.getter]: (state) => state.dismissedPlacementTabExplanation,
};

export default getters;
